export const getBackendBaseUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND || process.env.REACT_APP_BACKEND_URL || '';
  return envUrl.replace(/\/api\/v1\/?$/, '').replace(/\/$/, '') || 'http://localhost:8080';
};

export const getFrontendBaseUrl = () => {
  const envUrl = process.env.REACT_APP_FRONTEND_URL || process.env.REACT_APP_CLIENT_URL || '';
  if (envUrl) return envUrl.replace(/\/$/, '');
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return `${window.location.protocol}//${host}:5173`;
    }
    if (host.startsWith('admin.')) {
      return `${window.location.protocol}//${host.replace('admin.', '')}`;
    }
  }
  return 'https://studentunion.au';
};

export const getFullImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
    return path;
  }
  const base = getBackendBaseUrl();
  return `${base}${path.startsWith('/') ? '' : '/'}${path}`;
};
